import { Link } from "react-router";
import { t } from '../../locales/translate.js';

function Header({ user, setCookie, route }) {
  // Function to handle logout
  const handleLogout = () => {
    setCookie('token', '', { path: '/' });
    setCookie('user', '', { path: '/' });
    window.location.href = '/login'; // Redirect to login page
  };

  return (
    <div className="page-header">
      <div className="header-wrapper row m-0">
        <div className="main-header">
          <div className="header-left">
            <div className="logo-wrapper">
              <Link to="/">
                <img className="img-fluid" src="/assets/images/logo/logo_dark.png" alt="logo" />
              </Link>
            </div>

            <ul className="nav-menu">
              {user?.role_id && user?.role_id !== 3 && (
                <li className={route === '/' ? 'nav-item active' : 'nav-item'}>
                  <Link className="nav-link" to="/">
                    <i className="fa-solid fa-file-lines"></i>
                    {t('Reports')}
                  </Link>
                </li>
              )}
              {user?.role_id === 3 && (
                <li className={route === '/transport' ? 'nav-item active' : 'nav-item'}>
                  <Link className="nav-link" to="/transport">
                    <i className="fa-solid fa-truck"></i>
                    {t('Transport')}
                  </Link>
                </li>
              )}

              {user?.role_id === 3 && (
                <li className={route === '/transport-documents' ? 'nav-item active' : 'nav-item'}>
                  <Link className="nav-link" to="/transport-documents">
                    <i className="fa-solid fa-file-invoice"></i>
                    {t('Transport_documents')}
                  </Link>
                </li>
              )}

              {(user?.role_id === 2 || user?.role_id === 4) && ( // Hunter and Depot
                <li className={route === '/invoices' ? 'nav-item active' : 'nav-item'}>
                  <Link className="nav-link" to="/invoices">
                    <i className="fa-solid fa-file-invoice"></i>
                    {t('Fakturor')}
                  </Link>
                </li>
              )}

              {!user?.id && (<li className={route === '/login' ? 'nav-item active' : 'nav-item'}>
                <Link className="nav-link" to="/login">
                  <i className="fa-solid fa-right-to-bracket"></i>
                  {t('Login')}
                </Link>
              </li>)}

              {!user?.id && (<li className={route === '/register' ? 'nav-item active' : 'nav-item'}>
                <Link className="nav-link" to="/register">
                  <i className="fa-solid fa-user-plus"></i>
                  {t('Register')}
                </Link>
              </li>)}

              {user?.role_id > 0 && ((user?.role_id !== 3) || (user?.role_id !== 4)) && (<li className={route === '/add' ? 'nav-item active' : 'nav-item'}>
                <Link className="nav-link" to="/add">
                  <i className="fa-solid fa-plus"></i>
                  {t('add_report')}
                </Link>
              </li>)}

              {!user?.role_id && (<li className={route === '/add' ? 'nav-item active' : 'nav-item'}>
                <Link className="nav-link" to="/add">
                  <i className="fa-solid fa-plus"></i>
                  {t('add_report_unregistered')}
                </Link>
              </li>)}

            </ul>
          </div>
          <ul className="nav-menus">
            {user?.id && (
              <li className="profile-nav onhover-dropdown pe-0 py-0">
                <div className="d-flex profile-media">
                  <div className="flex-grow-1 user-account">
                    <span>
                      {user.name}
                    </span>
                    <p className="mb-0 user-account-email">
                      {user.email} <i className="middle fa-solid fa-angle-down"></i>
                    </p>
                  </div>
                </div>
                <ul className="profile-dropdown onhover-show-div">
                  <li>
                    <Link to="/account">
                      <i className="fa-solid fa-user"></i>
                      <span className="menu-item">{t('Account')}</span>
                    </Link>
                  </li>

                  <li>
                    <Link className="nav-link" to="mailto:info@ekovilt.se">
                      <i className="fa-solid fa-envelope"></i>
                      <span className="menu-item">{t('Kontakta oss')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="nav-link" to="/terms">
                      <i className="fa-solid fa-file-contract"></i>
                      <span className="menu-item">{t('Terms & Conditions')}</span>
                    </Link>
                  </li>
                  <li>
                    <span onClick={() => { handleLogout() }}>
                      <i className="fa-solid fa-sign-out-alt"></i>
                      <span className="menu-item">{t('Log out')}</span>
                    </span>
                  </li>
                </ul>
              </li>)}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Header;
